export default "__VITE_ASSET__DmkUqla3__"